import { createRoute, lazyRouteComponent } from '@tanstack/react-router';
import { z } from 'zod';

import { DEFAULT_PAGE_NUMBER, DEFAULT_LOAD_MORE } from '../../../../constants';
import { clientTransactionsRoute } from '../route';

export const clientTransactionsStandingOrdersPageValidateSearchSchema =
	z.object({
		openedStandingOrder: z.string().optional(),
		pageNumber: z.number().prefault(DEFAULT_PAGE_NUMBER),
		loadMore: z.number().prefault(DEFAULT_LOAD_MORE),
	});

export const clientTransactionsStandingOrdersRoute = createRoute({
	path: '/standing-orders',
	getParentRoute: () => clientTransactionsRoute,
	component: lazyRouteComponent(
		() => import('./ClientTransactionsStandingOrdersPage'),
		'ClientTransactionsStandingOrdersPage',
	),
	validateSearch: clientTransactionsStandingOrdersPageValidateSearchSchema,
});
